/* eslint-disable import/prefer-default-export */
import graphqlClient from '../graphql';
import {
  createInvoiceGql,
  editInvoiceGql,
  getInvoiceDetailsGql,
  listInvoiceGroupsGql,
  listInvoicesGql,
  updateInvoiceGroupBillToGql,
  voidInvoiceGql,
} from './gql';

export const listInvoiceGroupsApi = () => {
  return graphqlClient
    .request(listInvoiceGroupsGql)
    .then(({ listInvoiceGroups }) => listInvoiceGroups);
};

export const listInvoicesApi = ({
  invoiceGroupId,
  invoiceId,
  startDate,
  endDate,
  sortOrder,
  limit,
  offset,
}) => {
  return graphqlClient
    .request(listInvoicesGql, {
      filter: { invoiceGroupId, invoiceId, startDate, endDate },
      sort: { sortKey: 'INVOICE_DATE', sortOrder },
      limit,
      offset,
    })
    .then(({ listInvoices }) => listInvoices);
};

export const getInvoiceDetailsApi = ({ invoiceId }) => {
  return graphqlClient
    .request(getInvoiceDetailsGql, { invoiceId })
    .then(({ getInvoiceDetails }) => getInvoiceDetails);
};

export const voidInvoiceApi = ({ invoiceId }) => {
  return graphqlClient
    .request(voidInvoiceGql, { invoiceId })
    .then(({ voidInvoice }) => voidInvoice);
};

export const editInvoiceApi = ({ invoiceId, invoiceLineItems, customerMessage }) => {
  return graphqlClient
    .request(editInvoiceGql, { invoiceId, invoiceLineItems, customerMessage })
    .then(({ editInvoice }) => editInvoice);
};

export const createInvoiceApi = ({
  invoiceGroupId,
  billingPeriodStart,
  billingPeriodEnd,
  invoiceDate,
  dueDate,
  invoiceLineItems,
  customerMessage,
}) => {
  return graphqlClient
    .request(createInvoiceGql, {
      input: {
        invoiceGroupId,
        billingPeriodStart,
        billingPeriodEnd,
        invoiceDate,
        dueDate,
        invoiceLineItems,
        customerMessage,
      },
    })
    .then(({ createInvoice }) => createInvoice);
};

export const updateInvoiceGroupBillToApi = ({ invoiceGroupId, billTo }) => {
  return graphqlClient
    .request(updateInvoiceGroupBillToGql, { invoiceGroupId, billTo })
    .then(({ updateInvoiceGroupBillTo }) => updateInvoiceGroupBillTo);
};
